

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useFetchClasses from "../../hooks/useFetchClasses";
import { ApiUrl } from "../../../ApiUrl"
import CertificateStyledForm, {
  certificateFieldStyle,
} from "./CertificateStyledForm";
const TransferCertificateForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedClassId, setSelectedClassId] = useState("");
  const studentData = location.state || {}; // Retrieve the state (student data) passed from HomePage
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [formData, setFormData] = useState({
    ...studentData,
    ...studentData.studentcertificatedetails,
  });
  const [isFieldsDisabled, setIsFieldsDisabled] = useState(false);
  const [selectedClass, setSelectedClass] = useState(
    localStorage.getItem("selectedClassId") || ""
  );
  const handleClose = () => {
    const keysToRetain = [
      "academicSessionId",
      "branchId",
      "nextAcademicSessionId",
      "orgId",
    ];
    const retainedValues = keysToRetain.reduce((acc, key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});
    localStorage.clear();
    Object.entries(retainedValues).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    navigate("/admin/student-certificate");
  };
  const handleClassChange = (e) => {
    const classId = e.target.value;

    if (classId) {
      localStorage.setItem("selectedStudentClassId", classId);
    } else {
      localStorage.removeItem("selectedStudentClassId");
    }

    // Update formData with the new classId and reset sectionId
    setFormData((prev) => ({
      ...prev,
      classId,
      sectionId: "", // Reset section when class changes
    }));

    setSelectedClassId(classId); // Trigger sections fetch with the selected class ID
  };

  const handleSave = async () => {
    try {
      // Validate tc_applied_date
      if (!formData.tc_applied_date) {
        alert("Date of Application for Certificate is required.");
        return; // Stop execution if validation fails
      }

      // Validate tc_issued_date
      if (!formData.tc_issued_date) {
        alert("Date of Issue of Certificate is required.");
        return; // Stop execution if validation fails
      }

      // Retrieve values from local storage
      const student =
        localStorage.getItem("selectedCertificateStudentId") ||
        localStorage.getItem("studentId") ||
        formData.studentId ||
        formData.student ||
        "";
      const session = localStorage.getItem("academicSessionId");
      const org_id = localStorage.getItem("orgId");
      const branch_id = localStorage.getItem("branchId");
      const document_type =
        localStorage.getItem("selectedDocumentType") ||
        localStorage.getItem("documentType") ||
        localStorage.getItem("document_type") ||
        formData.documentType ||
        formData.document_type ||
        "";

      // Ensure the Document No. is split and validated
      const [prefix, ...rest] = (formData.document_no || "").split("/");
      const postfix = rest.join("/");

      if (!prefix || !postfix) {
        alert("Please provide a valid Document No. in the format 'prefix/postfix'.");
        return;
      }

      // Default value for transfer_certificate_no
      const transferCertificateNo = formData.transfer_certificate_no || "4";
      const transferCertificateId =
        localStorage.getItem("transfer_certificate_id") || 0;

      // Prepare the payload
      const payload = {
        student,
        session,
        org_id,
        branch_id,
        document_type,
        transfer_certificate_no_prefix: prefix,
        transfer_certificate_no_postfix: postfix,
        transfer_certificate_no: transferCertificateNo, // Defaulted to 4 if not provided
        transfer_certificate_id: Number(transferCertificateId) || 0,
        tc_applied_date: formData.tc_applied_date || null,
        reason_for_tc: formData.reason_for_tc || "",
        tc_issued_date: formData.tc_issued_date || null,
        ncc_cadet_details: formData.ncc_cadet_details || "",
        games_played_details: formData.games_played_details || "",
        general_conduct: formData.general_conduct || "",
        other_remarks: formData.other_remarks || "",
        status: formData.status || "N",
        school_board_last_taken: formData.school_board_last_taken || "",
        whether_failed: formData.whether_failed || "",
        subjects_studied: formData.subjects_studied || "",
        qualified_for_promotion: formData.qualified_for_promotion || "",
        month_fee_paid: formData.month_fee_paid || "",
        fee_concession_availed: formData.fee_concession_availed || "",
        total_no_working_days: formData.total_no_working_days || "",
        total_no_working_days_present: formData.total_no_working_days_present || "",
        cancelled_on: formData.cancelled_on || null,
        cancelled_remarks: formData.cancelled_remarks || "",
        cancelled_by: formData.cancelled_by || "",
        rollno: formData.rollno || "",
        cultural_activities: formData.cultural_activities || "",
        other_activities: formData.other_activities || "",
        marks_obtained: formData.marks_obtained || "",
        from_month: formData.from_month || "",
        to_month: formData.to_month || "",
        class_last_studied: formData.classId || "", // Mapping classId to class_last_studied
        // ✅ Add CBSE Registration No
        cbse_reg_no: formData.cbse_reg_no || "",
      };

      // API Call
      const isEditMode = Number(transferCertificateId) > 0;
      const requestUrl = isEditMode
        ? `${ApiUrl.apiurl}transfer-certificate/update/${session}/${branch_id}/${org_id}/${transferCertificateId}/`
        : `${ApiUrl.apiurl}transfer-certificate/`;

      const response = await fetch(requestUrl, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        alert(
          isEditMode
            ? "Character Certificate updated successfully!"
            : "Character Certificate saved successfully!"
        );
        console.log(result);

        // After the successful API call, clear the specified fields from localStorage
        // Retain the specific fields
        const academicSessionId = localStorage.getItem("academicSessionId");
        const branchId = localStorage.getItem("branchId");
        const nextAcademicSessionId = localStorage.getItem("nextAcademicSessionId");
        const orgId = localStorage.getItem("orgId");

        // Clear all other fields from localStorage
        localStorage.clear(); // This will clear everything

        // Retain the necessary fields after clearing
        localStorage.setItem("academicSessionId", academicSessionId);
        localStorage.setItem("branchId", branchId);
        localStorage.setItem("nextAcademicSessionId", nextAcademicSessionId);
        localStorage.setItem("orgId", orgId);

        // Navigate to the student certificate page
        navigate("/admin/student-certificate", {
          state: { refreshCertificates: Date.now() },
        });
      } else {
        const error = await response.json();
        alert(`Error saving Transfer Certificate: ${error.message}`);
      }
    } catch (error) {
      console.error("Error while saving:", error);
      alert("An error occurred while saving the Transfer Certificate.");
    }
  };

  const handleClearForm = () => {
    setFormData((prev) => ({
      ...prev,

      // 🔹 Editable fields to clear
      studentname: "",
      father_name: "",
      mother_name: "",
      dob: "",
      classId: "",
      rollno: "",
      marks_obtained: "",
      subjects_studied: "",
      general_conduct: "",
      ncc_cadet_details: "",
      cultural_activities: "",
      games_played_details: "",
      other_activities: "",
      tc_applied_date: "",
      tc_issued_date: "",
      other_remarks: "",
      reason_for_tc: "",
      month_fee_paid: "",
      fee_concession_availed: "",
      total_no_working_days: "",
      total_no_working_days_present: "",
      school_board_last_taken: "",
      whether_failed: "",

      // ✅ Add missing CBSE registration no reset
      cbse_reg_no: "",
    }));
  };

  const actionButtons = (
    <>
      <button
        type="button"
        className="btn btn-primary me-2"
        style={{ width: "150px" }}
        onClick={handleSave}
      >
        {Number(localStorage.getItem("transfer_certificate_id") || 0) > 0
          ? "Update"
          : "Save"}
      </button>
      <button
        type="button"
        className="btn btn-secondary me-2"
        style={{ width: "150px" }}
        onClick={handleClearForm}
      >
        Clear
      </button>
      <button
        type="button"
        className="btn btn-danger me-2"
        style={{ width: "150px" }}
        onClick={handleClose}
      >
        Close
      </button>
    </>
  );

  const characterRows = [
    {
      label: "Student Barcode",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.barcode || ""}
          onChange={(e) => setFormData({ ...formData, barcode: e.target.value })}
        />
      ),
    },
    {
      label: "Cancellation Remarks",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.cancellationRemarks || formData.cancelled_remarks || ""}
          onChange={(e) =>
            setFormData({
              ...formData,
              cancellationRemarks: e.target.value,
              cancelled_remarks: e.target.value,
            })
          }
        />
      ),
    },
    {
      label: "Cancelled On",
      control: (
        <input
          type="date"
          style={certificateFieldStyle}
          value={formData.cancelledOn || formData.cancelled_on || ""}
          onChange={(e) =>
            setFormData({
              ...formData,
              cancelledOn: e.target.value,
              cancelled_on: e.target.value,
            })
          }
        />
      ),
    },
    {
      label: "Status",
      control: (
        <select
          style={certificateFieldStyle}
          value={formData.status || "N"}
          onChange={(e) => setFormData({ ...formData, status: e.target.value })}
        >
          <option value="N">New</option>
          <option value="A">Approved</option>
          <option value="C">Cancelled</option>
        </select>
      ),
    },
    {
      label: "Father's / Guardian's Name",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.father_name || ""}
          onChange={(e) => setFormData({ ...formData, father_name: e.target.value })}
        />
      ),
    },
    {
      label: "Mother's Name",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.mother_name || ""}
          onChange={(e) => setFormData({ ...formData, mother_name: e.target.value })}
        />
      ),
    },
    {
      label: "Date of Birth",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.dob || ""}
          onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
        />
      ),
    },
    {
      label: "Class",
      control: (
        <select
          style={certificateFieldStyle}
          value={formData.classId || ""}
          onChange={handleClassChange}
        >
          <option value="">Select Class</option>
          {classes.map((classItem) => (
            <option key={classItem.id} value={classItem.id}>
              {classItem.classname}
            </option>
          ))}
        </select>
      ),
    },
    {
      label: "CBSE Registration No",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.cbse_reg_no || ""}
          onChange={(e) => setFormData({ ...formData, cbse_reg_no: e.target.value })}
        />
      ),
    },
    {
      label: "Board Roll No.",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.rollno || ""}
          onChange={(e) => setFormData({ ...formData, rollno: e.target.value })}
        />
      ),
    },
    {
      label: "Marks",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.marks_obtained || ""}
          onChange={(e) => setFormData({ ...formData, marks_obtained: e.target.value })}
        />
      ),
    },
    {
      label: "Subjects",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.subjects_studied || ""}
          onChange={(e) => setFormData({ ...formData, subjects_studied: e.target.value })}
        />
      ),
    },
    {
      label: "Conduct and Behaviour",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.general_conduct || ""}
          onChange={(e) => setFormData({ ...formData, general_conduct: e.target.value })}
        />
      ),
    },
    {
      label: "NSS/NCC/SCOUT/GUIDE",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.ncc_cadet_details || ""}
          onChange={(e) => setFormData({ ...formData, ncc_cadet_details: e.target.value })}
        />
      ),
    },
    {
      label: "Cultural Activities",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.cultural_activities || ""}
          onChange={(e) => setFormData({ ...formData, cultural_activities: e.target.value })}
        />
      ),
    },
    {
      label: "Games & Sports",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.games_played_details || ""}
          onChange={(e) => setFormData({ ...formData, games_played_details: e.target.value })}
        />
      ),
    },
    {
      label: "Other Activities",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.other_activities || ""}
          onChange={(e) => setFormData({ ...formData, other_activities: e.target.value })}
        />
      ),
    },
    {
      label: "Date of Application for Certificate",
      control: (
        <input
          type="date"
          style={certificateFieldStyle}
          value={formData.tc_applied_date || ""}
          onChange={(e) => setFormData({ ...formData, tc_applied_date: e.target.value })}
        />
      ),
    },
    {
      label: "Remarks",
      control: (
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.other_remarks || ""}
          onChange={(e) => setFormData({ ...formData, other_remarks: e.target.value })}
        />
      ),
    },
  ];

  return (
    <CertificateStyledForm
      title="CHARACTER CERTIFICATE"
      actions={actionButtons}
      documentNoControl={
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.document_no || ""}
          onChange={(e) => {
            const value = e.target.value.trim();
            const [prefix, ...rest] = value.split("/");
            const postfix = rest.join("/");
            setFormData({
              ...formData,
              document_no: value,
              transfer_certificate_no_prefix: prefix || "",
              transfer_certificate_no_postfix: postfix || "",
            });
          }}
        />
      }
      dateControl={
        <input
          type="date"
          style={certificateFieldStyle}
          value={formData.tc_issued_date || ""}
          onChange={(e) => setFormData({ ...formData, tc_issued_date: e.target.value })}
        />
      }
      introNameControl={
        <input
          type="text"
          style={certificateFieldStyle}
          value={formData.studentname || ""}
          onChange={(e) => setFormData({ ...formData, studentname: e.target.value })}
        />
      }
      rows={characterRows}
    />
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <h3 className="text-center mb-4">Character Certificate</h3>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    {Number(localStorage.getItem("transfer_certificate_id") || 0) > 0
                      ? "Update"
                      : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClearForm}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    {" "}
                    Close{" "}
                  </button>
                </div>
              </div>

              <form>
                <div className="col-12 mb-3 custom-section-box">
                  <div className="row mb-3 mt-3">
                    <div className="col-md-6 d-flex align-items-center">
                      <label
                        className="form-label me-3"
                        style={{ width: "200px" }}
                      >
                        Document No.
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.document_no || ""}
                        onChange={(e) => {
                          const value = e.target.value.trim();
                          // Extract prefix and postfix based on the example format "4/2024-25"
                          const [prefix, ...rest] = value.split("/"); // Split on "/"
                          const postfix = rest.join("/"); // Join the remaining parts for postfix

                          setFormData({
                            ...formData,
                            document_no: value,
                            transfer_certificate_no_prefix: prefix || "", // "4"
                            transfer_certificate_no_postfix: postfix || "", // "2024-25"
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6 d-flex align-items-center">
                      <label
                        className="form-label me-3"
                        style={{ width: "200px" }}
                      >
                        {" "}
                        Student Barcode{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.barcode || ""}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                      <label
                        className="form-label me-3"
                        style={{ width: "200px" }}
                      >
                        {" "}
                        Cancellation Remarks{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.cancellationRemarks || ""}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                      <label
                        className="form-label me-3"
                        style={{ width: "200px" }}
                      >
                        {" "}
                        Cancelled On{" "}
                      </label>
                      <input
                        type="date"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.cancelledOn || ""}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                      <label className="col-sm-3 col-form-label ms-2">
                        {" "}
                        Status{" "}
                      </label>
                      <select className="form-select detail">
                        {" "}
                        <option value="">New</option>{" "}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Additional fields */}
                <ul className="list-unstyled  mb-3 mt-3 custom-section-box">
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">1.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      Student Name
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.studentname || ""}
                      />{" "}
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">2.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      Father's/ Guardian's Name
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.father_name || ""}
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">3.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      Mother's Name
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.mother_name || ""}
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">4.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Date of birth (in Christian Era) according to the
                      Admission Register (in figures) (in words)
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        disabled={isFieldsDisabled}
                        defaultValue={formData.dob || ""}
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">3.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Class{" "}
                    </label>
                    <div className="col-sm-2">
                      <select
                        id="admitted-class"
                        className="form-select detail"
                        value={formData.classId}
                        onChange={handleClassChange}
                        required
                      >
                        <option value="">Select Class</option>
                        {classes.map((classItem) => (
                          <option key={classItem.id} value={classItem.id}>
                            {classItem.classname}
                          </option>
                        ))}
                      </select>
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">6.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      CBSE Registration No{" "}
                    </label>
                    <div className="col-sm-6">
                      {" "}
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.cbse_reg_no || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            cbse_reg_no: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>

                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">7.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Board Roll No.{" "}
                    </label>
                    <div className="col-sm-6">
                      {" "}
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.rollno || ""}
                        onChange={(e) =>
                          setFormData({ ...formData, rollno: e.target.value })
                        }
                      />{" "}
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">8.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Marks{" "}
                    </label>
                    <div className="col-sm-6">
                      {" "}
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.marks_obtained || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            marks_obtained: e.target.value,
                          })
                        }
                      />{" "}
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">9.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      Subjects{" "}
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        // disabled={isFieldsDisabled}

                        value={formData.subjects_studied || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            subjects_studied: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">10.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Conduct and Behaviour{" "}
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.general_conduct || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            general_conduct: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">11.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      NSS/NCC/SCOUT/GUIDE{" "}
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.ncc_cadet_details || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            ncc_cadet_details: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">12.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      CULTURAL ACTIVITIES{" "}
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder=""
                        value={formData.cultural_activities || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            cultural_activities: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">13.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      GAMES & SPORTS
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        // defaultValue={formData.total_working_day || "0"}
                        value={formData.games_played_details}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            games_played_details: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">14.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      OTHER ACTIVITIES
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        // defaultValue={formData.total_present_day || "0"}
                        value={formData.other_activities}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            other_activities: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>

                  {/* <li className="mb-3 d-flex align-items-center">
            <span className="col-sm-1 text-end">20.</span>
            <label className="col-sm-3 col-form-label ms-2">  Date of Application for Certificate*  </label>
            <div className="col-sm-8">  <input type="date" className="form-control" />   </div>
          </li> */}

                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">15.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      Date of Application for Certificate
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="date"
                        className="form-control detail"
                        value={formData.tc_applied_date || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            tc_applied_date: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>

                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">16.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Date of Issue of Certificate
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-6">
                      {" "}
                      <input
                        type="date"
                        className="form-control detail"
                        value={formData.tc_issued_date || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            tc_issued_date: e.target.value,
                          })
                        }
                      />{" "}
                    </div>
                  </li>

                  <li className="mb-3 d-flex align-items-center">
                    <span className="col-sm-1 text-end">17.</span>
                    <label className="col-sm-3 col-form-label ms-2">
                      {" "}
                      Remarks{" "}
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control detail"
                        placeholder="Enter remarks"
                        style={{ resize: "both", overflow: "auto" }}
                        rows="3"
                        value={formData.other_remarks || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            other_remarks: e.target.value,
                          })
                        }
                      />
                    </div>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferCertificateForm;
